/*
 * Module for the groups/addgroupmembers page
 */
rs.module("content/security/administration/groups/addgroupmembers",

    [],

    function () {

        // initialize the module
        function initialize(jsSelectors, addGroupMembersGridLrsApi) {

            // TODO: This can be removed if/when we implement the changes detailed in Task 122483 / item #24 of Task 116160
            _configureGridSelection();

            // js selectors
            var addSelectedButton = $.js(jsSelectors.addSelectedButton);

            // Disable the AddSelected button if nothing is selected
            addGroupMembersGridLrsApi.selectionChanged(function (values, rows) {
                addSelectedButton.setDisabled(values[0] == null);
            });

            // show disabled checkboxes in the leftmost column & set selectable
            function _configureGridSelection() {

                // Loop through the grid's nodes and mark InGroup nodes as unselectable
                addGroupMembersGridLrsApi.agGridApi.forEachNode((node) => node.selectable = !node.data.IsInGroup);
                addGroupMembersGridLrsApi.agGridApi.deselectAll();
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);